<ngx-spinner 
bdColor = "rgba(0, 0, 0, 0.8)" 
size = "medium" color = "#ee0909" 
type = "ball-atom" 
[fullScreen] = "true">
<p style="color: white" > cargando .... </p>
</ngx-spinner>
<div class="panel  "  *ngIf="!tablaEstandar" >
    <div class="row">
        <div class="container">
            <div class="col-sm-11">
                <img src="./assets/images/Elementos/Carruse01.jpg"  class="carrucel" />

            </div>
        </div>
<br>
    </div>
    <!--div class="encabezado col-sm-10"  *ngIf="!tablaEstandar">     
<img src="./assets/images/Elementos/sectoresT.png"  class="titleIma" />
    </div-->

    <div class="row">
        <div class="container">
   
    <div class=" col-sm-12 leyenda3"  *ngIf="!tablaEstandar"  >     
<p>SECTORES PRODUCTIVOS</p>
    </div>
</div>
</div>
<br>

 <div class="row">
     <div class="container">
        
            <div class="col-sm-12  leyenda" >
<p>
Consulta aquí el catálogo donde puedes encontrar todos los Estándares de Competencia por ocupación que describen, en términos 
de resultados, el conjunto de conocimientos, habilidades, destrezas y actitudes que requieres para realizar una 
actividad en el ámbito laboral, social, gobierno o educativo.
</p>
            </div>

     </div> 
 </div>
<br>


<div class="row">
    <div class="container">
           <div class="col-sm-12  leyenda1" >
            <p>¿QUÉ ES EL SCIAN ?</p>
          
           
            <p class="leyenda2" >
               Es el  Sistema de Clasificación Industrial de América del Norte (SCIAN), mismo que sirve para clasificar las actividades económicas del país. Su ordenamiento está basado en funciones de producción de las unidades económicas. Permite homologar y estandarizar toda la información económica que se produce en el país y su comparación nacional e internacional.
            </p>
        </div>
    </div>
    </div>
    
    <div class="container">
        <div class="col-sm-1">
            <br>
            &nbsp; <span><img src="./assets/images/icon/lupa.png" class="iconLupa"></span>
        </div>
        <div class="col-sm-11">
            <mat-form-field  appearance="standard">
                <mat-label>Búsqueda de sectores productivos por estándar</mat-label>
                <input matInput #message  placeholder="Ingresa aquí las palabras claves del Estándar que deseas buscar"
                 (keyup)="getSectoresByEstandar($event)">
                <!-- <mat-hint align="end">{{message.value.length}} / 256</mat-hint> -->
              </mat-form-field>
        </div>
    </div>
    <br>
    <br>
<div class="row" *ngIf="!tablaEstandar" >
    <div  class="container">
        <div *ngFor="let listado of listado  index as i"  class="panel col-sm-4">
            <div class="panel">
        <div    class="img" *ngIf="listado.tipo!=21">
            <img src="./assets/images/Elementos/{{listado.nombreImagen}}"  class="img-responsive imagen2 mi-cursor" (click)="sectorByID(listado)">
                
        </div>

    
        <br>
        <div class="panel-heading2 mi-cursor  col-auto bg-danger p-5 tex-center" id={{i}}  (click)="sectorByID(listado)"  *ngIf="listado.tipo!=21">
            <p>{{listado.descripcion}}</p>
        </div>
            
    </div>   
    <!--div class="panel"> <p class="encabezadoImg">Estandares : {{listado.noEstandares}}</p></div-->    
       
</div>
    </div>
</div>

</div>

<br>

<div class="row">
    <div class="container">
<div class=" col-sm-12 leyenda4 mi-cursor " (click)="sectorByTra()"  *ngIf="!tablaEstandar  "  >     
    <p>ESTÁNDARES DE COMPETENCIA TRANSVERSALES </p>
        </div>
    </div>
</div>
<br>
<br>
<div class="panel panel-danger "  *ngIf="tablaEstandar" >
 
    <div class="panel-heading encabezado"  *ngIf="tablaEstandar"  >     
        <p class="encabezado">{{title}}</p>
        
            </div>
    <br>
    <div class="row"  *ngIf="tablaEstandar" >
    <div class="container">
        <div class="col-sm-1" *ngIf="longitud>0" >
            <br>
            &nbsp; <span ><img  src="./assets/images/icon/lupa.png"  class="iconLupa" ></span>
        </div>
    <div  class="col-sm-11" *ngIf="longitud>0">
    <mat-form-field appearance="standard">
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input>
    </mat-form-field>
</div>
</div>
</div>
<div class="row"  *ngIf="tablaEstandar" >
    <div class="container example-container">
<div  class="col-sm-12" >

        <div class="alert alert-info" *ngIf="longitud==0" role="alert">
           <p class="letraE">No existen EC's por el momento para ese sector.</p> 
          </div>
    
    <div class="mat-elevation-z8" *ngIf="longitud>0" >
        <table mat-table [dataSource]="dataSource"  class="table table-striped table-bordered" >
          
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef  class="letraD marcaAgua">ID</th>
                <td mat-cell *matCellDef="let element" (click)="sectorByID(element)"class="letraE">{{idSector === 0 ? element.codigoSec : element.tipo}} </td>
            </ng-container>

            <ng-container matColumnDef="descripcion">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua" >Subsector</th>
                <td mat-cell *matCellDef="let element" (click)="sectorByID(element)" class="letraE">{{element.descripcion}} </td>
            </ng-container>

            <ng-container matColumnDef="noestandares">
                <th mat-header-cell *matHeaderCellDef  class="letraD marcaAgua">Número de estándares</th>
                <td mat-cell *matCellDef="let element" (click)="subectorByID(element)" class="letraE">{{element.noEstandares}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
        </table>
        <mat-paginator
                 showFirstLastButtons 
                 aria-label="Select page of periodic elements">
        </mat-paginator>
      
        
    </div>
</div>
</div>
</div>


  


        <br>
        <div class="row">
            <div class="container">
        <div class="col-sm-5" ></div>
<div style="text-align: center;" class="col-sm-1" >
    <button mat-button (click) = "back()"><img src="./assets/images/icon/Atras.png"  class=" imagen" /></button>
</div>
<div style="text-align: center;"  class="col-sm-1">
    <button mat-button (click) = "home()"><img src="./assets/images/icon/Home.png"  class=" imagen" /></button>
</div>
</div>
</div>
<br>

</div>